/*!

    Tooltip

*/
(function($){
    $.fn.sbViTooltip = function() {

        var $this = this;
        var tooltipCls = $this[0].className.match(/(sb-vi-tooltip-left|sb-vi-tooltip-top|sb-vi-tooltip-right|sb-vi-tooltip-bottom)/)[0];

        $this.tooltip({
          position     : getPosition(tooltipCls),
          tooltipClass : tooltipCls + " sb-vi-tooltip-box",
          show         : { effect: "show" },
          hide         : { effect: "hide" }
        });

        if($this.hasClass('sb-vi-tooltip-display-on-click-on-mobile') && jQuery.browser.mobile) {
          $this.unbind('mouseover mouseleave');
          $this.on('click', function() {
            if($this.attr('title')) {
              $this.tooltip('open');
            } else {
              $this.tooltip('close');
            }
          });
        }

        function getPosition(cls)
        {
          switch(cls)
          {
            case 'sb-vi-tooltip-left'   : return { my: "right-10 center", at: "left center"}
            case 'sb-vi-tooltip-top'    : return { my: "bottom bottom",   at: "bottom top-10"}
            case 'sb-vi-tooltip-right'  : return { my: "left+10 center",  at: "right center"}
            case 'sb-vi-tooltip-bottom' : return { my: "top top",         at: "top bottom+10"}
            default                     : return { my: "bottom bottom",   at: "bottom top-10"}
          }
        }

    };

})(jQuery);

/*!
    Notifications
*/
globalThis.sbNotification = function(){
    $(document).on('click', '.sb-vi-alert button', function(){
       var $alertBox = $(this).parents('.sb-vi-alert');
       $alertBox.fadeOut(500,function() {
          $alertBox.remove();
       });
    });
}

globalThis.dropHover = function(){
  var $dropdownsHover = $('.sb-vi-dropdown.onhover');
  $dropdownsHover.each(function(){
      var $this = $(this);
      $this.hover(function(){
        $this.addClass('open');
      }, function(){
        $this.removeClass('open');
      });
  });
}

$(document).on("ready page:load", function(){
  $('.sb-vi-tooltip').each(function(){ $(this).sbViTooltip(); });
  sbNotification();
  dropHover();
});
